/**
 * @fileoverview Agent definition for world-element-detailer-v3.
 *
 * Enriches detected world elements with descriptions proportional to
 * their classification (critical/major/minor).
 *
 * @category world-building.extraction.enrichment
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'world-element-detailer-v3',
  kind: 'primitive',
  name: 'World Element Detailer',
  description: 'Enriches detected world elements with descriptions proportional to their classification.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.extraction.enrichment',
    usedBy: [],
    usedInComposites: ['extract-world-elements-v3'],
    relatedAgents: [
      'world-element-core-detector-v3',
      'world-element-rare-detector-v3',
    ],
  },
};
